"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDevSettings = void 0;
var _reactRedux = require("react-redux");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var useDevSettings = function useDevSettings() {
  var _useSelector = (0, _reactRedux.useSelector)(_widgetSelectors.selectDevSettings),
    showStickyFooter = _useSelector.showStickyFooter;
  var _useSelector2 = (0, _reactRedux.useSelector)(_widgetSelectors.selectDevSettings),
    showOtherPlans = _useSelector2.showOtherPlans;
  return {
    showStickyFooter: showStickyFooter,
    showOtherPlans: showOtherPlans
  };
};
exports.useDevSettings = useDevSettings;